import { Form, FormRule, InputNumber } from "antd";
import * as React from "react";
import { ZodNumber, ZodNumberFormat } from "zod";
import { $ZodCheckGreaterThan, $ZodCheckLessThan } from "zod/v4/core";

import { FieldDef, itemName, makeLabel } from "../attrMetaEditorUtils";

/* eslint no-underscore-dangle: ["error", { "allow": ["_zod"] }]  */

type PropsNumberEd = {
  node: ZodNumber;
  path: string[];
  field?: FieldDef;
};

export const NumberEd: React.FC<PropsNumberEd> = (props) => {
  const { node, path, field } = props;
  const rules: FormRule[] = [];
  let precision: number | undefined;
  let min: number | undefined;
  let max: number | undefined;
  if (!field?.optional) {
    rules.push({ required: true, message: "Необходимо заполнить поле" });
  }
  node.def.checks?.forEach((ch) => {
    if (ch instanceof ZodNumberFormat) {
      if (ch._zod.def.format === "safeint") {
        precision = 0;
      }
    } else if (ch instanceof $ZodCheckGreaterThan) {
      min = Number(ch._zod.def.value);
    } else if (ch instanceof $ZodCheckLessThan) {
      max = Number(ch._zod.def.value);
    } else {
      // eslint-disable-next-line no-console
      console.log("unknown Number check >>", ch);
    }
  });
  return (
    <Form.Item
      name={itemName(path)}
      label={makeLabel(node, path, field)}
      rules={rules}
    >
      <InputNumber
        precision={precision}
        min={min}
        max={max}
        title={path.join(".")}
      />
    </Form.Item>
  );
};
